import { RefreshCwIcon } from "lucide-react";

import { Button } from "src/components/ui/button";

export const RefreshButton = ({
  onClick,
  loading,
  title = "Refresh",
  size = "sm",
  variant = "ghost",
  className,
}) => {
  return (
    <Button
      size={size}
      variant={variant}
      onClick={onClick}
      disabled={loading}
      title={title}
      className={className}
    >
      <RefreshCwIcon className={loading && "animate-spin"} />
    </Button>
  );
};

export default RefreshButton;
